export const featuredPortfolio = [
    {
        id: 1,
        title: "WeSpace Social Media App",
        img: "assets/images/we-space.png",
        github: "https://github.com/johnbabat/wespace-merng-social-media-app",
        site: "https://lucid-neumann-81fe7a.netlify.app/"
    },
    {
        id: 2,
        title: "Urrl",
        img: "assets/images/urrl.png",
        github: "https://github.com/johnbabat/urrl-backend",
        site: "https://urrl.link"
    },
    {
        id: 3,
        title: "Portfolio",
        img: "assets/images/portfolio.png",
        github: "https://github.com/johnbabat/DSN-staff-promotion-algorithm"
    },
    {
        id: 4,
        title: "WebSockets Chat App",
        img: "assets/images/chat-app.png",
        github: "https://github.com/johnbabat/web-sockets-chat-app",
        site: "https://glacial-dawn-82621.herokuapp.com/"
    },
    {
        id: 5,
        title: "Dashboard Admin App",
        img: "assets/images/admin-dashboard.png",
        github: "https://github.com/johnbabat/react-dashboard-app",
        site: "https://comforting-tiramisu-bef5b4.netlify.app/"
    },
    {
        id: 6,
        title: "Netflix Clone",
        img: "assets/images/netflix-clone.png",
        github: "https://github.com/johnbabat/netflix-clone",
        site: "https://netflix-clone-9bcaf.web.app/"
    },
    {
        id: 7,
        title: "Fyurr Musical",
        img: "assets/images/fyurr-app.png",
        github: "https://github.com/johnbabat/fyurr-musical-app"
    },
    {
        id: 8,
        title: "Daily Coding Challenges",
        img: "assets/images/daily-coding.png",
        github: "https://github.com/johnbabat/Daily-Coding-Challenges"
    }
]



export const webPortfolio = [
    {
        id: 1,
        title: "WeSpace Social Media App",
        img: "assets/images/we-space.png",
        github: "https://github.com/johnbabat/wespace-merng-social-media-app",
        site: "https://lucid-neumann-81fe7a.netlify.app/"
    },
    {
        id: 2,
        title: "Urrl",
        img: "assets/images/urrl.png",
        github: "https://github.com/johnbabat/urrl-backend",
        site: "https://urrl.link"
    },
    {
        id: 3,
        title: "WebSockets Chat App",
        img: "assets/images/chat-app.png",
        github: "https://github.com/johnbabat/web-sockets-chat-app",
        site: "https://glacial-dawn-82621.herokuapp.com/"
    },
    {
        id: 4,
        title: "Fyurr Musical",
        img: "assets/images/fyurr-app.png",
        github: "https://github.com/johnbabat/fyurr-musical-app"
    },
    {
        id: 5,
        title: "Dashboard Admin App",
        img: "assets/images/admin-dashboard.png",
        github: "https://github.com/johnbabat/react-dashboard-app",
        site: "https://comforting-tiramisu-bef5b4.netlify.app/"
    },
    {
        id: 6,
        title: "Netflix Clone",
        img: "assets/images/netflix-clone.png",
        github: "https://github.com/johnbabat/netflix-clone",
        site: "https://netflix-clone-9bcaf.web.app/"
    },
    {
        id: 7,
        title: "MERN Shopping Site",
        img: "assets/images/shopping-cart.png",
        github: "https://github.com/johnbabat/mern-shopping-site",
        site: "https://secure-island-75094.herokuapp.com/"
    },
    {
        id: 8,
        title: "Spotify Clone",
        img: "assets/images/spotify-clone.png",
        github: "https://github.com/johnbabat/spotify-clone"
    },
    {
        id: 9,
        title: "Dashboard Admin App",
        img: "assets/images/admin-dashboard.png",
        github: "https://github.com/johnbabat/react-dashboard-app",
        site: "https://comforting-tiramisu-bef5b4.netlify.app/"
    },
    {
        id: 10,
        title: "Portfolio",
        img: "assets/images/portfolio.png",
        github: "https://github.com/johnbabat/DSN-staff-promotion-algorithm"
    },
    {
        id: 11,
        title: "Basic Weather App",
        img: "assets/images/weather-app.png",
        github: "https://github.com/johnbabat/nodejs-weather-app"
    }
]



export const codingPortfolio = [
    {
        id: 1,
        title: "Daily Coding Challenges",
        img: "assets/images/daily-coding.png",
        github: "https://github.com/johnbabat/Daily-Coding-Challenges"
    },
    {
        id: 2,
        title: "May LeetCoding Challenge",
        img: "assets/images/may-leetcode.png",
        github: "https://github.com/johnbabat/May-LeetCoding-Challenge",
    },
    {
        id: 3,
        title: "30 Days LeetCoding Challenge",
        img: "assets/images/30-day-leetcode.png",
        github: "https://github.com/johnbabat/30-Day-Leetcoding-Challenge"
    }
]



export const MLPortfolio = [
    {
        id: 1,
        title: "Staff Promotion Model",
        img: "assets/images/staff-promotion.png",
        github: "https://github.com/johnbabat/DSN-staff-promotion-algorithm"
    },
    {
        id: 2,
        title: "Student Admission NN Model",
        img: "assets/images/student-admission.png",
        github: "https://github.com/johnbabat/Predicting-Student-Admissions-with-Neural-Networks"
    },
    {
        id: 3,
        title: "Spam Detection Model",
        img: "assets/images/spam-detector.png",
        github: "https://github.com/johnbabat/Udacity-ML-engineer-nanodegree-projects/tree/master/Spam_detector"
    },
    {
        id: 4,
        title: "Boston Housing Prediction",
        img: "assets/images/boston-housing.png",
        github: "https://github.com/johnbabat/Udacity-ML-engineer-nanodegree-projects/tree/master/Boston_housing"
    },
    {
        id: 5,
        title: "Finding Donors Model",
        img: "assets/images/finding-donors.png",
        github: "https://github.com/johnbabat/Udacity-ML-engineer-nanodegree-projects/tree/master/finding_donors"
    },
    {
        id: 6,
        title: "Customer Analysis",
        img: "assets/images/customer-analysis.png",
        github: "https://github.com/johnbabat/Customer-Analysis"
    },
    
]